import { Contact } from '@app/contacts/models/contact';

export enum CoverPageOptions {
  None = 'none',
  Compose = 'compose',
  File = 'file',
  Template = 'template',
}

export enum SentFaxStatus {
  Answered = 'answered',
  Pending = 'pending',
  Success = 'success',
  Failed = 'failed',
  Error = 'error',
}

export interface FaxDestination {
  contact?: Contact;
  phoneNumber: string;
}

export interface SendFaxData {
  coverPage: CoverPageOptions;
  coverPageText: string | undefined;
  coverPageUrl: FaxUrlResponse | undefined;
  coverPageTemplate: CoverPageTemplate | undefined;
  urls: FaxUrlResponse[];
  callerId: string;
  destinations: FaxDestination[];
}

export const ALLOWED_FAX_FILES: string[] = ['.html', '.pdf', '.doc', '.docx', '.jpg', '.png', '.tiff', '.txt'];
export const MAX_FAX_FILE_SIZE_BYTES = 75 * 1024 * 1024; // 75MB

export interface FaxMessage {
  id: string;
  caller_id: string;
  destination: number;
  created_by?: string;
  created_at: string;
  pages: number;
  pdf?: string;
  thumbnail?: string;
  confirmation?: string;
  status: string;
  transcription?: string;
  direction: 'inbound' | 'outbound';
  alias?: string[] | string;
  unread: boolean | false;
  contact?: Contact;
  read?: boolean;
}

export interface FaxDeletedMessage {
  id: string;
  status: string;
  alias?: string[] | string;
}

export interface FaxesDeletedMessage {
  ids: string[];
  status: string;
  alias?: string[] | string;
}

export interface FaxMessageResponse {
  data: FaxMessage[];
  links: FaxLinks;
}

export interface FaxLinks {
  first?: string;
  last?: string;
  prev?: string | undefined;
  next: string | null;
}

export const AllLocalFaxNumber: LocalFaxNumber = {
  number: 'all',
};

export interface ListFaxNumbersResponse {
  success: boolean;
  message: string;
  data: LocalFaxNumber[];
}

export interface LocalFaxNumber {
  number: string;
  callback_url?: string[];
  email_address?: string[];
  description?: string;
  shared?: boolean;
}

export interface FaxUrlResponse {
  filename: string;
  key: string;
  url: string;
}

export interface ShareFax {
  id: string;
  destination: string;
  callerId: string;
  dateTime: string;
  pages: number;
  direction: 'inbound' | 'outbound';
}

export interface CoverPageTemplate {
  name: string;
  top_text: string;
  organization_name: string;
  organization_address: string;
  phone_number: string;
  website: string;
  bottom_text: string;
  logo_url: string | null;
  id: number;
  template_url: string;
}

export interface CoverPageApiTemplate extends CoverPageTemplate {
  domain: string;
  created_at: string;
  updated_at: string;
}

export interface ListFaxCoverPageApiTemplatesResponse {
  success: boolean;
  templates: CoverPageTemplate[];
}
